import React, { useEffect, useState } from 'react'
import "./login.scss";
import logo from "../../assets/images/logo/logo-dsd.png";
import backgroundImage from "../../assets/images/backforlogin.jpg";
import Footer from '../../components/Footer/Footer';
import { useNavigate } from 'react-router';
import { useForm,SubmitHandler } from 'react-hook-form';
import Input  from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useRecoilState } from 'recoil';
import { RecoilloadState, UserInfoStateRecoil } from '../../utilities/globaleState';
import API from '../../utilities/API';
import Erreurs from '../../components/Erreurs/Erreurs';
import { useRedirectAfterLogin } from '../../hooks';

interface UserInput {
   username:string;
   password:string,
 }

interface Error {
   msg: string;
}
const schema = z.object({
   username: z.string({
      required_error: "Le nom d'utilisateur est obligatoire.",
      invalid_type_error: "Le nom d'utilisateur doit être de type chaine de caractère.",
   }).min(2,{message: "Le caractère minimum est deux."}),
   password: z.string()
});

function Login() {
  const navigate = useNavigate();
  const { redirectAfterLogin } = useRedirectAfterLogin();
  const [userInfo,setUserInfo ] = useState<UserInput>({username:'',password:''});
  const {
   register,
   handleSubmit,
   watch,
   formState: { errors },
 } = useForm<UserInput>();
 const [ userInfoState , setUserInfoState ] = useRecoilState(UserInfoStateRecoil);
 const [isLoading,setIsLoading ] = useRecoilState(RecoilloadState);
 const [ erreurs,setErreurs ] = useState<Error[]>([])
 const api = new API();

  const Authentify :SubmitHandler<UserInput> = async (data) => {
  
     setIsLoading(true);setErreurs([]);
       var formData = new FormData();
       formData.append('username',data.username);
       formData.append('password',data.password);
       const rep = await api.auth(formData);
       if( rep === undefined ){
        // console.log("Erreur de connexion, veuillez réessayer plus tard.");
         setErreurs([{ msg:"Erreur de connexion, veuillez réessayer plus tard." }]);
         setIsLoading(false);
         return;
      }
       if( rep?.status !== 200 ){
          setErreurs(rep?.errors);
       }else {
         const user = rep.user.user;
         //delete user._id;
         setUserInfoState(user);

         // Rediriger vers la page précédente sauvegardée
         // redirectAfterLogin(navigate);
         navigate("/newrecepisse");
       }
     setIsLoading(false);
    
  }  
//   console.log(userInfoState)
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
     setUserInfo({...userInfo,[e.target.name] : e.target.value})
  }

  useEffect(() => {
    // Sauvegarder le chemin actuel avant de se connecter
    const currentPath = window.location.pathname;
   
    if (currentPath === '/') {
       if(localStorage.getItem('token')) {
         navigate("/newrecepisse");
       } else {
         sessionStorage.setItem('redirectAfterLogin', currentPath);
       }
    }

  }, []);

  return (
    <div className='login' style={{backgroundImage: `url(${backgroundImage})`}}>
        <div className='login__overlay'>
          <div className='login__form'>
            <form onSubmit={handleSubmit(Authentify)}>
                 <div className='login__form__heading'>
                    <div className='logo'>
                      <img src={logo} alt='logo-DSD' />
                    </div>
                    <div className='title'>
                       <h3>Connexion</h3>
                    </div>
                 </div>
                 <div className='login__form__body'>
                  <Erreurs validation={erreurs} />
                    <div className='input-group'>
                       <div>
                         <Input 
                           label="Utilisateur"
                           icon="user"
                           placeholder="Utilisateur"
                           size="md"
                           variant="default"
                           fullWidth
                           id="username"
                           {...register('username', {
                             onChange: (e) => {
                               handleInput(e)
                             },
                             required: true,
                             minLength: 3,
                             maxLength: 30
                           })}
                           error={
                             errors.username?.type === "required" ? "Le Nom d'utilisateur est obligatoire." :
                             errors.username?.type === "minLength" ? "Le minimum de caractère est trois (3)." :
                             errors.username?.type === "maxLength" ? "Le caractère maximum est trente (30)." :
                             undefined
                           }
                         />
                       </div>
                       <div>
                         <Input 
                           label="Mot de Passe"
                           icon="password"
                           type="password"
                           placeholder="Mot de passe"
                           size="md"
                           variant="default"
                           fullWidth
                           id="password"
                           {...register('password', {
                             onChange: (e) => {
                               handleInput(e)
                             },
                             required: true
                           })}
                           error={
                             errors.password?.type === "required" ? "Le mot de passe est obligatoire." :
                             undefined
                           }
                         />
                       </div>
                    </div>
                    {/* <div>
                        <button type='submit' className={`${isLoading?'no-pointer':''}`}  disabled={isLoading}> {!isLoading ?"Connecter": "Connecter..."}</button>
                    </div> */}
                    <div>
                      <Button type='submit' variant='primary' size='md' disabled={isLoading} loading={isLoading}>
                      {!isLoading ? "Connecter" : "Connecter..."}
                    </Button>
                    </div>
                   
                 </div>
            </form>
          </div>
      
        </div>
    </div>
  )
}

export default Login